module.exports = __webpack_public_path__ + "img/tpay-landing-page-en.d5efeaf6.png";